import { useTranslation } from 'react-i18next';
import ProductErrorBoundary from './ProductErrorBoundary';

// Productos declarativos
import BusinessSolutionDeclarative from '../paginaProducto/businessSolution/BusinessSolutionDeclarative';
import SmartSenDeclarative from '../paginaProducto/smartsen/SmartSenDeclarative';
import SmartSscDeclarative from '../paginaProducto/smartSsc/SmartSscDeclarative';
import SmartSuiteDeclarative from '../paginaProducto/smartSuite/SmartSuiteDeclarative';
import SscEnterpriseDeclarative from '../paginaProducto/sistemaDeIntervencionYControl/SscEnterpriseDeclarative';
import SmartIotDeclarative from '../paginaProducto/smartIot/SmartIotDeclarative';
import FactoryScadaDeclarative from '../paginaProducto/factoryScada/FactoryScadaDeclarative';
import EvoScadaServerDeclarative from '../paginaProducto/evoScadaServer/EvoScadaServerDeclarative';
import IvrDeclarative from '../paginaProducto/interactiveVoiceResponse/IvrDeclarative';
import GeontrackerDeclarative from '../paginaProducto/geontracker/GeontrackerDeclarative';
import WhatsappDeclarative from '../paginaProducto/whatsappBot/WhatsappDeclarative';
import ConsejarDeclarative from '../paginaProducto/conseJar/ConsejarDeclarative';
import SyncFlowDeclarative from '../paginaProducto/syncFlow/SyncFlowDeclarative';

const PRODUCT_MAP = {
  'business-solution': BusinessSolutionDeclarative,
  'smartsen': SmartSenDeclarative,
  'smartssc': SmartSscDeclarative,
  'smartsuite': SmartSuiteDeclarative,
  'ssc-enterprise': SscEnterpriseDeclarative, // 👈 ESTE ES EL CLAVE
  'smartiot': SmartIotDeclarative,
  'factoryscada': FactoryScadaDeclarative,
  'evoscadaserver': EvoScadaServerDeclarative,
  'ivr': IvrDeclarative,
  'geontracker': GeontrackerDeclarative,
  'whatsapp': WhatsappDeclarative,
  'consejar': ConsejarDeclarative,
  'syncflow': SyncFlowDeclarative,
};


const ProductPageRenderer = ({ product }) => {


  const { t } = useTranslation();

  const ProductComponent = PRODUCT_MAP[product];

  if (!ProductComponent) {
    return <div style={{ padding: 40 }}>Producto no encontrado</div>;
  }

  return (
    <ProductErrorBoundary>
      <ProductComponent t={t} />
    </ProductErrorBoundary>
  );
};

export default ProductPageRenderer;
